// src/pages/ItemLedger/index.js
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography, Drawer,Tooltip} from "antd";
import ItemLedgerFilters from "./components/ItemLedgerFilters";
import ItemLedgerTable from "./components/ItemLedgerTable";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import "./index.scss";

const { Title } = Typography;

const ItemLedger = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.itemLedger);
  const navigate = useNavigate();

  const reportRef = useRef(null);
  const [helpOpen, setHelpOpen] = useState(false);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Item Ledger Report",
    removeAfterPrint: true,
  });

  const handleNavigateToBack = () => {
    navigate(-1);
  };

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          // title={<div style={{ display: "flex", alignItems: "center" }}>
          //   <Button
          //     type="text"
          //     icon={<ArrowLeftOutlined />}
          //     onClick={handleNavigateToBack}
          //     style={{ marginRight: 8 }}
          //   /><Title level={4} style={{ margin: 0 }}>Item Ledger</Title>
          //   </div>}
          title={<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="text"
                  icon={<ArrowLeftOutlined />}
                  onClick={handleNavigateToBack}
                  style={{ marginRight: 8 }}
                />

                <Title level={4} style={{ margin: 0 }}>
                  Item Ledger
                </Title>
              </div>

              <Tooltip title="Help">
                <Button
                  type="text"
                  icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
                  onClick={() => setHelpOpen(true)}
                />
              </Tooltip>
            </div>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <ItemLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <ItemLedgerTable />
        </Card>
      </App>
      <Drawer
        title="Item Ledger Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Item Ledger Report
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Item Ledger Report module is used to track item-wise stock
            movement and transaction history within the ERP system. It helps
            monitor inventory inflow, outflow, balances, and stock activity
            for reporting and auditing purposes.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to View Item Ledger</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Inventory → Item Ledger</strong></li>
              <li>Select required filters and date range</li>
              <li>Choose item/product if required</li>
              <li>Review stock inflow and outflow entries</li>
              <li>Verify transaction references and balances</li>
              <li>Analyze inventory movement history</li>
              <li>Use Print option to generate report copy if needed</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Ledger balances update automatically after transactions.</li>
              <li>Filters can be used to narrow report results.</li>
              <li>Printed reports reflect current ledger data.</li>
              <li>Item ledger helps track complete stock movement history.</li>
            </ul>
          </div>
        </div>
      </Drawer>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Item Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <ItemLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default ItemLedger;
